import Index from 'src/pages/Locations/Products/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/locations/:id/products',
    name: 'Produkte Standort',
    component: Index,
    meta: auth
  }
]
